export const en = {
  header: {
    title: 'Dr. Khoshtaria',
  },
  nav: {
    about: 'About',
    services: 'Services',
    education: 'Educational Resources',
    askDoctor: 'Ask Doctor',
    contact: 'Contact'
  },
  education: {
    title: 'Educational Resources',
    subtitle: 'Curated video content to help you better understand women\'s health',
    georgian: {
      title: 'Educational Resources in Georgian',
      watchVideo: 'Watch Video'
    },
    english: {
      title: 'Educational Resources in English',
      watchVideo: 'Watch Video'
    },
    russian: {
      title: 'Educational Resources in Russian',
      watchVideo: 'Watch Video'
    }
  },
  hero: {
    title: 'Dr. Mamuka Khoshtaria',
    subtitle: 'Renowned Obstetrician-Gynecologist with over 40 years of expertise in women\'s health',
    cta: 'Book Appointment',
  },
  stats: {
    childbirths: {
      number: '20,000+',
      text: 'Successful Childbirths',
    },
    complications: {
      number: '2,000+',
      text: 'Complicated Cases Managed',
    },
    surgeries: {
      number: '3,000+',
      text: 'Complex Surgeries',
    },
    experience: {
      number: '40+',
      text: 'Years of Experience',
    },
  },
  expertise: {
    title: 'Expertise & Specializations',
    subtitle: 'With decades of experience in obstetrics and gynecology, Dr. Khoshtaria has successfully handled thousands of cases, from routine deliveries to complex surgical procedures.',
    services: {
      obstetrics: {
        title: 'Obstetrics Care',
        description: 'Comprehensive pregnancy care, from prenatal to postnatal services, with expertise in handling both routine and high-risk pregnancies.',
      },
      surgery: {
        title: 'Gynecologic Surgery',
        description: 'Specialized in complex gynecologic procedures, including oncologic and urogynecologic surgeries.',
      },
      health: {
        title: "Women's Health",
        description: "Dedicated to providing comprehensive women's healthcare services across all life stages.",
      },
      additional: {
        title: 'Additional Services',
        description: 'Offering specialized services including fertility treatments, minimally invasive procedures, and preventive care consultations.',
      },
    },
  },
  contact: {
    title: 'Contact Information',
    subtitle: 'Schedule an appointment or get in touch with any questions you may have.',
    getInTouch: 'Get in Touch',
    mobile: 'Mobile',
    office: 'Office',
    currentWorkplaces: 'Current Workplaces',
    phone: '+995 599 43 66 77',
    landline: '+995 032 2 52 05 25',
    email: 'mamuka_khoshtaria@yahoo.com',
    clinics: {
      openHeart: 'Open Heart - University Hospital',
      barbara: 'Barbara Reproductive Health Clinic'
    },
    hours: 'Monday - Friday: 9:00 AM - 6:00 PM',
    appointments: 'Appointments available',
  },
  footer: {
    copyright: '© {year} Dr. Mamuka Khoshtaria. All rights reserved.',
  },
  aiChat: {
    title: 'AI Medical Assistant',
    backToHome: 'Back to Home',
    description: 'This AI assistant can help you with:',
    capabilities: {
      general: 'General medical information and guidelines',
      symptoms: 'Common symptoms and conditions',
      recommendations: 'Basic health recommendations',
      pregnancy: 'Pregnancy and women\'s health information'
    },
    disclaimer: 'Please note: The AI provides general information only and should not replace professional medical advice.',
    askDoctor: {
      title: 'Ask Dr. Khoshtaria',
      description: 'Have a specific question for Dr. Khoshtaria? Leave your question here, and the doctor will personally review and respond to your inquiry during business hours. You can also attach relevant medical documents to help the doctor better understand your situation.',
      instructions: {
        title: 'How to Ask a Question',
        steps: 'Provide your contact information so we can reach you\nWrite your medical question in detail\nAttach relevant medical documents (optional)\nSubmit your question and wait for response via email'
      },
      attachments: {
        title: 'Supporting Documents',
        description: 'You can attach relevant medical documents such as:',
        voice: {
          title: 'Voice Recording',
          description: 'You can record your voice to explain your question in detail',
          start: 'Start Recording',
          stop: 'Stop Recording',
          delete: 'Delete Recording',
          duration: 'Recording duration: {seconds} seconds',
          instructions: 'Click to start recording your voice message. Speak clearly and describe your medical concern in detail.',
          processing: 'Processing...',
          error: 'Recording error',
          tryAgain: 'Please try recording again.',
          recordedLabel: 'Voice message recorded'
        },
        types: 'Lab test results\nMedical imaging reports\nPrevious medical records\nPrescription documents',
        limits: 'Accepted formats: Images, PDF, DOC. Max size: 10MB per file',
        button: 'Add Documents',
        remove: 'Remove',
        subtitle: 'Test results, imaging reports or medical records help the doctor answer more precisely',
        note: 'Up to 30 files, 10MB each. Text from PDF and Word documents is read automatically.',
        processingCount: 'Processing {count} file(s)...',
        uploadingTitle: 'Uploading files',
        inProgress: '{count} file(s) in progress',
        pleaseWait: 'Please wait while we process your files...',
        listTitle: 'Attached files',
        counter: '{current}/{max} files',
        processingShort: 'Processing...',
        pageProgress: 'Page {current} of {total}',
        timeRemaining: '{time} remaining',
        extractedOk: 'Text extracted ({pages} pages, {chars}k characters)',
        previewLabel: 'Extracted text preview:',
        imageReady: 'Image ready ({size} MB)',
        fileReady: 'Ready ({size} MB)',
        errorLabel: 'Error',
        methodOcr: 'OCR',
        methodStandard: 'TEXT'
      },
      emailNote: 'You will receive the response via email',
      contact: {
        title: 'Contact Details',
        subtitle: 'The doctor\'s answer will be sent to your email'
      },
      questionHint: 'Describe your concern in as much detail as you can — or record a voice message below',
      orSpeak: 'or record a voice message',
      optionalTag: 'optional',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email',
      phonePlaceholder: 'Phone (optional)',
      label: 'Your Question',
      placeholder: 'Type your medical question here...',
      submit: 'Submit Question',
      submitSaving: 'Saving your question…',
      submitUploading: 'Uploading attachments…',
      error: 'There was an error submitting your question. Please try again.',
      success: {
        title: 'Thank you for your question!',
        message: 'Dr. Khoshtaria will review and respond to your inquiry via email as soon as possible.',
        askAnother: 'Ask another question'
      }
    }
  },
  askDoctor: {
    form: {
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email'
    }
  },
  chat: {
    title: 'AI Medical Assistant',
    subtitle: 'Get expert medical guidance available 24/7',
    disk: {
      medicalAssistance: 'Medical Assistance',
      healthGuidance: 'Health Guidance',
      expertSupport: 'Expert Support',
      available: '24/7 Available'
    },
    welcome: 'Ask me any medical questions based on Dr. Khoshtaria\'s expertise',
    placeholder: 'Type your question here...',
    error: 'I apologize, but I\'m having trouble connecting. Please try again.',
    online: 'Online',
    typing: 'Typing...',
    thinking: 'Thinking...',
    sources: 'Sources',
    reasoning: {
      label: 'Deep reasoning',
      tooltip: 'When on, the assistant reasons more deeply and searches the web for better answers.',
      on: 'On',
      off: 'Off'
    },
    inputAriaLabel: 'Message input',
    sendAriaLabel: 'Send message',
    sectionTitle: 'AI Assistant',
    sectionSubtitle: 'Use the AI chatbot to help answer common questions',
    quickReplies: {
      appointments: 'How can I schedule an appointment?',
      services: 'What services do you offer?',
      location: 'Where is your clinic located?'
    },
    actions: {
      newChat: 'New chat',
      history: 'Chat history',
      collapse: 'Collapse chat',
      attach: 'Attach files',
      remove: 'Remove file',
      editSend: 'Edit & Send'
    },
    history: {
      title: 'Chat History',
      back: 'Back to Chat',
      empty: 'No previous conversations found',
      view: 'View',
      delete: 'Delete',
      confirmDelete: 'Delete this conversation? This action cannot be undone.',
      loadFailed: 'Failed to load conversations',
      deleteFailed: 'Failed to delete conversation'
    },
    attachment: {
      preview: 'Extracted text preview',
      extracted: 'Text extracted',
      pages: 'pages',
      page: 'Page',
      error: 'Error'
    },
    voice: {
      start: 'Record a voice message',
      stop: 'Stop recording',
      noSpeech: 'No speech detected in the recording. Please try again.',
      failed: 'Could not transcribe the recording.'
    },
    editForm: {
      title: 'Edit & Send AI Response',
      emailLabel: 'Patient Email *',
      phoneLabel: 'Patient Phone',
      questionLabel: 'Original Question',
      originalLabel: 'Original AI Response',
      responseLabel: 'Edit Response *',
      emailPlaceholder: 'Enter patient email',
      phonePlaceholder: 'Enter patient phone',
      questionPlaceholder: 'Enter the original question',
      responsePlaceholder: 'Edit the AI response here...',
      downloadPdf: 'Download PDF',
      cancel: 'Cancel',
      send: 'Send to Patient',
      sending: 'Sending...'
    }
  },
  admin: {
    nav: {
      backToHome: 'Back to Home',
      chatHistory: 'Chat History',
      logout: 'Logout'
    },
    aiAssistant: {
      title: 'AI Assistant',
      subtitle: 'Use the AI chatbot to help answer common questions'
    },
    questions: {
      title: 'Patient Questions',
      subtitle: 'Manage and respond to patient inquiries',
      filterAll: 'All Questions',
      filterPending: 'Pending',
      filterAnswered: 'Answered',
      statusAnswered: 'Answered',
      statusPending: 'Pending',
      newReply: 'New reply',
      questionPreviewLabel: 'Question',
      respond: 'Respond',
      pdf: 'PDF',
      delete: 'Delete',
      questionDetails: 'Question Details',
      patientQuestion: 'Patient Question',
      aiInitialResponse: 'AI Initial Response',
      yourResponse: 'Your Response',
      generatedAt: 'Generated: {date}',
      sentAt: 'Sent: {date}',
      voiceMessage: 'Voice Message',
      durationSeconds: 'Duration: {seconds} seconds',
      attachments: 'Attachments',
      answeredOn: 'Answered: {date}',
      emptyTitle: 'No questions yet',
      emptyMessage: 'Patient inquiries will appear here once they are submitted.',
      errorTitle: 'Error',
      previewDownload: 'Download',
      confirmDelete: 'Are you sure you want to delete this question? This action cannot be undone.',
      responseSent: 'Response sent successfully!'
    },
    respondForm: {
      title: 'Respond to Patient',
      patientQuestionLabel: 'Patient Question',
      aiResponseLabel: 'AI Generated Response',
      yourResponseLabel: 'Your Response',
      responsePlaceholder: 'Edit or write your response here...',
      downloadPdf: 'Download PDF',
      cancel: 'Cancel',
      send: 'Send Response',
      sending: 'Sending...'
    }
  },
};